module.exports = __webpack_public_path__ + "media/images/pen_gold-67ae8c8f.png";